import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Create the React root and render the app
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
